import { Box, useMediaQuery, useTheme } from '@mui/material'

import React from 'react'

import { MainDesktop } from './Main.desktop'
import { MainMobile } from './Main.mobile'



export interface MapRefProps {
  map: mapboxgl.Map | null,
  mapContainer: HTMLDivElement | null,
}

export const Main = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))


  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        position: 'relative',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        height: '100%',

      }}
    >
      {!isMobile && (<MainDesktop/>)}
      {isMobile && (<MainMobile/>)}

    </Box>
  )
}
